import apiClient from "../common/apiClient";

export default class FeeSetupController {
  async Create(data, token) {
    try {
      return await apiClient.post("/fee-setup", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(id, data, token) {
    try {
      return await apiClient.put("/fee-setup/" + id, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/fee-setup/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllFeeSetup(token) {
    try {
      return await apiClient.get("/getAllFeeSetup", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
